import { create } from 'zustand'

interface EmailVerificationModalState {
  isOpen: boolean
  showModal: () => void
  hideModal: () => void
}

export const useEmailVerificationModal = create<EmailVerificationModalState>((set) => ({
  isOpen: false,
  showModal: () => set({ isOpen: true }),
  hideModal: () => set({ isOpen: false }),
}))
